(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  /* ===== Add to cart ===== */
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('vqp__form')) return;

    event.preventDefault();

    var button = form.querySelector('.vqp__atc-btn');
    var label = form.querySelector('.vqp__atc-label');
    if (!button || button.classList.contains('is-loading')) return;

    var idField = form.elements['id'];
    button.classList.add('is-loading');

    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(idField.value), quantity: 1 })
      });

      if (!response.ok) throw new Error('Add to cart failed');

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      if (label) label.textContent = button.getAttribute('data-added');

      if (form.getAttribute('data-after-add') === 'cart') {
        window.location.href = form.getAttribute('data-cart-url');
        return;
      }

      setTimeout(function () {
        button.classList.remove('is-added');
        if (label) label.textContent = button.getAttribute('data-label');
      }, 2200);
    } catch (error) {
      // Fall back to the normal form submit (goes to the cart page)
      form.submit();
    }
  });

  /* ===== Slider: arrows and dots ===== */
  (function () {
    function setup(root) {
      if (!root || root.__vqpReady) return;
      var track = root.querySelector('[data-vqp-track]');
      var dotsBox = root.querySelector('[data-vqp-dots]');
      var prev = root.querySelector('[data-vqp-prev]');
      var next = root.querySelector('[data-vqp-next]');
      if (!track || !dotsBox) return;
      root.__vqpReady = true;

      var pages = 1;

      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function build() {
        var overflow = maxScroll() > 4;
        var count = overflow ? Math.max(2, Math.ceil(track.scrollWidth / track.clientWidth - 0.05)) : 1;

        if (count !== pages || dotsBox.children.length !== (overflow ? count : 0)) {
          pages = count;
          dotsBox.innerHTML = '';
          if (overflow) {
            for (var i = 0; i < count; i++) {
              var dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'vqp__dot';
              dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
              dot.addEventListener('click', (function (index) {
                return function () {
                  track.scrollTo({ left: (maxScroll() * index) / (pages - 1), behavior: 'smooth' });
                };
              })(i));
              dotsBox.appendChild(dot);
            }
          }
        }

        dotsBox.hidden = !overflow;
        if (prev) prev.hidden = !overflow;
        if (next) next.hidden = !overflow;
        update();
      }

      function update() {
        var max = maxScroll();
        if (max <= 4) return;
        var active = Math.round((track.scrollLeft / max) * (pages - 1));
        var dots = dotsBox.children;
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === active);
        }
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', build);
      if (window.ResizeObserver) new ResizeObserver(build).observe(track);
      build();
    }

    function init() {
      document.querySelectorAll('[data-vqp]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector ? event.target.querySelector('[data-vqp]') : null;
      setup(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vediqo-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (!root || root.__vqrReady) return;
      root.__vqrReady = true;

      var track = root.querySelector('[data-vqr-track]');
      var prev = root.querySelector('[data-vqr-prev]');
      var next = root.querySelector('[data-vqr-next]');
      var cards = root.querySelectorAll('[data-vqr-card]');
      var modal = root.querySelector('[data-vqr-modal]');
      var player = root.querySelector('[data-vqr-player]');
      var mTitle = root.querySelector('[data-vqr-m-title]');
      var mText = root.querySelector('[data-vqr-m-text]');
      var mCta = root.querySelector('[data-vqr-m-cta]');
      var mode = root.getAttribute('data-mode') || 'auto';
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var modalOpen = false;

      function play(card) {
        var v = card.querySelector('video');
        if (!v || modalOpen) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }

      function pause(card) {
        var v = card.querySelector('video');
        if (v) v.pause();
      }

      cards.forEach(function (card) {
        var v = card.querySelector('video');
        if (v) {
          v.addEventListener('playing', function () { card.classList.add('is-playing'); });
          v.addEventListener('pause', function () { card.classList.remove('is-playing'); });
        }
      });

      /* Playback: autoplay when visible, or play on hover (desktop) */
      if (mode === 'hover' && canHover) {
        cards.forEach(function (card) {
          card.addEventListener('mouseenter', function () { play(card); });
          card.addEventListener('mouseleave', function () { pause(card); });
          card.addEventListener('focusin', function () { play(card); });
          card.addEventListener('focusout', function () { pause(card); });
        });
      } else if (mode !== 'off' && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              play(entry.target);
            } else {
              pause(entry.target);
            }
          });
        }, { threshold: [0, 0.6, 1] });
        cards.forEach(function (card) { io.observe(card); });
      }

      /* Arrows */
      function updateArrows() {
        if (!track) return;
        var overflow = track.scrollWidth - track.clientWidth > 4;
        if (prev) prev.hidden = !overflow;
        if (next) next.hidden = !overflow;
      }

      if (track) {
        if (prev) prev.addEventListener('click', function () {
          track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', function () {
          track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
        });
        window.addEventListener('resize', updateArrows);
        if (window.ResizeObserver) new ResizeObserver(updateArrows).observe(track);
        updateArrows();
      }

      /* Full screen player */
      function openModal(card) {
        var src = card.getAttribute('data-src');
        if (!src || !modal || !player) return;

        cards.forEach(pause);
        modalOpen = true;

        player.src = src;
        player.muted = false;
        mTitle.textContent = card.getAttribute('data-title') || '';
        mText.textContent = card.getAttribute('data-text') || '';

        var label = card.getAttribute('data-cta-label');
        var link = card.getAttribute('data-cta-link');
        if (label && link) {
          mCta.textContent = label;
          mCta.href = link;
          mCta.hidden = false;
        } else {
          mCta.hidden = true;
        }

        modal.hidden = false;
        document.body.classList.add('vqr-lock');
        var p = player.play();
        if (p && p.catch) p.catch(function () {});
        var closeBtn = modal.querySelector('.vqr__close');
        if (closeBtn) closeBtn.focus();
      }

      function closeModal() {
        if (!modal || modal.hidden) return;
        player.pause();
        player.removeAttribute('src');
        player.load();
        modal.hidden = true;
        modalOpen = false;
        document.body.classList.remove('vqr-lock');
        if (mode !== 'hover') {
          cards.forEach(function (card) {
            var r = card.getBoundingClientRect();
            if (r.left >= 0 && r.right <= window.innerWidth) play(card);
          });
        }
      }

      cards.forEach(function (card) {
        var btn = card.querySelector('[data-vqr-open]');
        if (btn) btn.addEventListener('click', function () { openModal(card); });
      });

      root.querySelectorAll('[data-vqr-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeModal();
      });
    }

    function init() {
      document.querySelectorAll('[data-vqr]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector ? event.target.querySelector('[data-vqr]') : null;
      setup(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
